import store from '../index'

/**
 * Maps to store accessor.
 * @param accessor Action accessor eg 'customers/resetState'
 * @example const logout = useMappedAction('customers/resetState')
 */
export const useMappedAction = (
  accessor: string
): ((payload?: unknown) => Promise<unknown>) => {
  return async (payload?: unknown) => await store.dispatch(accessor, payload)
}
